export const Trustly = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M0 10.9781H8.39515V4.2601L15.0983 10.9781L8.39515 17.6854V21.12H16.5317V10.9781H24V3.07202H0V10.9781Z" fill="#0EE06E"/>
</svg>`;
